import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from '../../../../../../../../context/AuthHelper';

import Schema from '../../../../../../../../lib/paths/antrag_FULL_Paths.json';
import SachkostenAntragLogMob, { getFormStrucSachkostenAntragLogMob } from './SachkostenAntragLogMob';
const P = Schema.attributes;

export const GetSachkostenAntragLogMob = (application: any, hasCommentAusgabenUndFinanzierung?: boolean) => {
	const unternehmenId = get(getLocalstorageToken(), 'organisationId');
	const OrgaStruc = [
		{
			label: get(application, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, `Antragsteller`),
			content: (
				<SachkostenAntragLogMob kostentraeger='Antragsteller' unternehmenId={unternehmenId} hasComment={hasCommentAusgabenUndFinanzierung} />
			),
			formStruc: getFormStrucSachkostenAntragLogMob(application, unternehmenId),
		},
	];
	const STRUC = get(application, P.Verbundpartner.path, []).map((_ele: any, i: number) => {
		const vPId = get(_ele, 'Verbundpartner.id');
		return {
			label: get(
				_ele,
				P.Verbundpartner.schema.attributes.Verbundpartner.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path.slice(
					P.Verbundpartner.path.length + 1,
				),
				`Verbundpartner ${i + 1}`,
			),
			content: <SachkostenAntragLogMob kostentraeger='Verbundpartner' unternehmenId={vPId} hasComment={hasCommentAusgabenUndFinanzierung} />,
			formStruc: getFormStrucSachkostenAntragLogMob(application, vPId),
		};
	});

	return [...OrgaStruc, ...STRUC];
};
